import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    flex1: {
        flex: 1
    },
    profileInfoContainer: {
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center"
    },
    contentSwitchContainer: {
        flexDirection: "row",
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center"
    },
    contentSwitchContent: {
        alignSelf: "stretch",
        flex: 1,
        alignItems: "center"
    },
    campaignImageContainer: {
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center"
    },
    campaignImage: {
        height: 200,
        width: "100%"
    },
    generalInfoContentContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        flex: 1
    },
    generalInfoContent: {
        flex: 1
    },
    profileInfoTextContainer: {
        flex: 1
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerIconsContainer: {
        position: "absolute",
        flexDirection: "row"
    },
    companyLogo: {
        width: 90,
        height: 90
    },
    tabSeparator: {
        height: "50%"
    },
    campaignTag: {
        position: "absolute"
    },
    campaignBottom: {
        position: "absolute"
    },
    employeePhoto: {
        width: 50,
        height: 50
    },
    lightboxContainer: {
        flex: 1,
        backgroundColor: "rgba(0,0,0,0.9)",
        justifyContent: "center",
        alignItems: "center"
    },
    lightboxCloseBtn: {
        position: "absolute",
        zIndex: 1
    },
    lightboxImage: {
        width: "100%",
        height: "80%"
    }
});
export default stylesheet;
